import React, { ReactNode } from 'react';
import { Avatar as MantineAvatar, type AvatarGroupProps } from '@mantine/core';

export interface IAvatarGroupProps extends Pick<AvatarGroupProps, 'spacing' | 'className' | 'style'> {
    /** Аватары группы (`Avatar` пакета или аватар приложения на нём) */
    children: ReactNode;
    /** Сколько ещё не показано: счётчик «+N» последним в группе; 0 и меньше — без счётчика */
    more?: number;
    /** Сторона счётчика, px — как у аватаров группы */
    moreSize?: number;
}

/** Стопка аватаров внахлёст (Mantine `Avatar.Group`); скрытый остаток — серый счётчик «+N». */
const AvatarGroup: React.FC<IAvatarGroupProps> = ({ children, more = 0, moreSize, ...rest }) => (
    <MantineAvatar.Group {...rest}>
        {children}
        {more > 0 && (
            <MantineAvatar size={moreSize} radius="xl" color="gray">
                +{more}
            </MantineAvatar>
        )}
    </MantineAvatar.Group>
);

export default AvatarGroup;
